import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-copilot-creative-modal',
  imports: [],
  templateUrl: './copilot-creative-modal.component.html',
  styleUrl: './copilot-creative-modal.component.scss'
})
export class CopilotCreativeModalComponent {
  public dialogData = inject(MAT_DIALOG_DATA);
}
